import { startCompletion } from "@codemirror/autocomplete"
import { fuzzyFilter } from "./fuzzy"

const COMMANDS = [
  { label: "Heading", detail: "# Act or chapter", insert: "# " },
  { label: "Subheading", detail: "## Scene", insert: "## " },
  { label: "Small heading", detail: "### Beat", insert: "### " },
  { label: "Scene break", detail: "* * *", insert: "* * *\n\n" },
  { label: "Quote", detail: "> spoken or cited", insert: "> " },
  { label: "List", detail: "- item", insert: "- " },
  { label: "Todo", detail: "- [ ] later", insert: "- [ ] " },
  { label: "Character", detail: "@ mention", retrigger: "@" },
  { label: "Location", detail: "+ mention", retrigger: "+" },
  { label: "Thread", detail: "# mention", retrigger: "#" },
  { label: "Embed", detail: "![[ card in the text", retrigger: "![[" }
]

export function slashCommands(context) {
  const match = context.matchBefore(/\/[\w-]*$/)
  if (!match) return null
  const line = context.state.doc.lineAt(match.from)
  if (match.from !== line.from) return null

  const query = match.text.slice(1)
  const commands = fuzzyFilter(query, COMMANDS, (command) => command.label)
  if (!commands.length) return null

  return {
    from: match.from,
    filter: false,
    options: commands.map((command) => ({
      label: command.label,
      detail: command.detail,
      apply: (view, _completion, from, to) => {
        const insert = command.insert ?? command.retrigger
        view.dispatch({
          changes: { from, to, insert },
          selection: { anchor: from + insert.length }
        })
        if (command.retrigger) startCompletion(view)
      }
    }))
  }
}
